import React from 'react';
const Footer=()=>{
    return(
        <>
            <footer>
                <p>&copy; Copyright 2020 | Avishake Maji, All Rights Reserved</p>
            </footer>
        </>
    )
}
export default Footer;